/* ============================================================
   BUUB Theme — theme.js
   ============================================================ */

(function () {
  'use strict';

  /* --- Promo bar dismiss --- */
  var promoBar   = document.getElementById('promo-bar');
  var promoClose = document.getElementById('promo-close');
  if (promoClose && promoBar) {
    promoClose.addEventListener('click', function () {
      promoBar.classList.add('hidden');
      document.body.classList.add('body--promo-hidden');
    });
  }

  /* --- Floating nav scroll effect --- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* --- Mobile menu --- */
  var hamburger = document.querySelector('.hamburger-btn');
  var drawer    = document.querySelector('.mobile-drawer');
  var overlay   = document.querySelector('.mobile-overlay');
  var closeBtn  = document.querySelector('.mobile-drawer-close');

  function openDrawer()  {
    hamburger && hamburger.classList.add('open');
    drawer    && drawer.classList.add('open');
    overlay   && overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    hamburger && hamburger.classList.remove('open');
    drawer    && drawer.classList.remove('open');
    overlay   && overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  hamburger && hamburger.addEventListener('click', openDrawer);
  closeBtn  && closeBtn.addEventListener('click', closeDrawer);
  overlay   && overlay.addEventListener('click', closeDrawer);

  /* --- Badge float-in animation --- */
  var badgeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.badge-item').forEach(function(badge) {
          badge.classList.add('badge-visible');
        });
        badgeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });
  var badgesRow = document.querySelector('.badges-row');
  if (badgesRow) badgeObserver.observe(badgesRow);

  /* --- FAQ accordion --- */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.faq-item');
      var answer = btn.nextElementSibling;
      var isOpen = item.classList.contains('open');

      /* close all */
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
        var a = i.querySelector('.faq-a');
        if (a) { a.hidden = true; }
        var b = i.querySelector('.faq-q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('open');
        if (answer) answer.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* --- Product page: qty stepper --- */
  window.buubQty = function (delta) {
    var val    = document.getElementById('qty-val');
    var hidden = document.getElementById('qty-hidden');
    if (!val) return;
    var n = Math.max(1, parseInt(val.textContent, 10) + delta);
    val.textContent = n;
    if (hidden) hidden.value = n;
  };

  /* --- Product page: image thumbnail switch --- */
  window.buubThumb = function (thumbEl, imgSrc) {
    document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumbEl.classList.add('active');
    var main = document.getElementById('product-main-image');
    if (main) main.src = imgSrc;
  };

  /* --- Product page: variant picker --- */
  document.querySelectorAll('.picker-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var group = opt.closest('.picker-options');
      group.querySelectorAll('.picker-opt').forEach(function (o) { o.classList.remove('active'); });
      opt.classList.add('active');
      var variantId = opt.dataset.variantId;
      if (variantId) {
        var hidden = document.querySelector('input[name="id"]');
        if (hidden) hidden.value = variantId;
      }
    });
  });

  /* --- Product page: tabs --- */
  window.buubTab = function (btn, panelId) {
    document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
    document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
    btn.classList.add('active');
    var panel = document.getElementById(panelId);
    if (panel) panel.classList.add('active');
  };

  /* --- Quickshop slide (basic) --- */
  window.buubSlide = function (trackId, dir) {
    var track = document.getElementById(trackId);
    if (!track) return;
    track.scrollBy({ left: dir * 300, behavior: 'smooth' });
  };

  /* --- Shade selector --- */
  document.querySelectorAll('.shade').forEach(function (shade) {
    shade.addEventListener('click', function () {
      var row = shade.closest('.shade-row');
      row.querySelectorAll('.shade').forEach(function (s) { s.classList.remove('active'); });
      shade.classList.add('active');
    });
  });

  /* --- Store locator search (placeholder) --- */
  var locatorInput = document.querySelector('.locator-input');
  var locatorBtn   = locatorInput && locatorInput.nextElementSibling;
  if (locatorBtn) {
    locatorBtn.addEventListener('click', function () {
      /* TODO: integrate Google Maps Places API */
      console.log('Search:', locatorInput.value);
    });
  }

})();
